import React, { useState, useEffect } from "react";
import "./IpSummary.scss";
import { Select, Radio, Progress, Button, Table, Spin } from "antd";
import iconCal from "../../../../Assets/svg/location4.svg";
import edit from "../../../../Assets/svg/editwhite.svg";
import snapshot1 from "../../../../Assets/svg/snapshot1.svg";
import snapshot2 from "../../../../Assets/svg/snapshot2.svg";
import snapshot3 from "../../../../Assets/svg/snapshot3.svg";
import snapshot4 from "../../../../Assets/svg/snapshot4.svg";
import snapshot5 from "../../../../Assets/svg/snapshot5.svg";
import snapshot6 from "../../../../Assets/svg/snapshot6.svg";
import IpCards from "./IpCards";
import ResourceSection from "./ResourceSection";
import LocationRatings from "./LocationRatings";
import deleteIcon from "../../../../Assets/svg/table-action-delete.svg";
import editIcon from "../../../../Assets/svg/table-action-edit.svg";
import previewIcon from "../../../../Assets/svg/table-action-preview.svg";
import EditIpModal from "./EditIpModal";
import TableView from "./TableView/TableView";
import { httpService } from "../../../../services/httpService.service";
import RedFlagCards from "./RedFlagCards";
import SiteVisitCards from "./SiteVisitCards";
import Map from "./Map";
import MapComponent from "../../../components/MapComponent/MapComponent";

const { Option } = Select;

function IpSummary() {
  const [periodType, setPeriodType] = useState("Month");
  const [shpwIpModal, setShowIpModal] = useState(false);
  const [implementingPartners, setImplementingPartners] = useState([]);
  const [selectedPartner, setSelectedPartner] = useState(null);
  const [projectData, setProjectData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [ipLoading, setIpLoading] = useState(true); // New state for loading IPs
  // Add local state for pagination
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    const workspaceId = localStorage.getItem("currentContractId");
    const apiIps = `/api/ImplementingPartner/getAllImplementingPartners?contractId=${workspaceId}&IgnorePagination=true`;

    setIpLoading(true); // Start loading indicator
    httpService.get(
      apiIps,
      (res) => {
        setImplementingPartners(res.data);
        setIpLoading(false); // Stop loading indicator
      },
      (error) => {
        console.error(error);
        setIpLoading(false); // Stop loading indicator on error
      }
    );
  }, []);

  useEffect(() => {
    const fetchProjectData = async () => {
      if (selectedPartner) {
        setLoading(true);
        try {
          const projectID = localStorage.getItem("currentProjectID");
          const apiProject = `/api/Projects/getIPsummary?implementingPartnerId=${selectedPartner}&projectId=${projectID}`;

          httpService.get(
            apiProject,
            (data) => {
              setProjectData(data);
              setLoading(false);
            },
            (error) => {
              console.error("Error fetching project data:", error);
              setLoading(false);
            }
          );
        } catch (error) {
          console.error("Error fetching project data:", error);
          setLoading(false);
        }
      }
    };

    fetchProjectData();
  }, [selectedPartner]);

  const handlePartnerChange = (value) => {
    setSelectedPartner(value);
  };
  return (
    <div className="IpSummaryDiv">
      {/* Label and picker on one line, the way every other toolbar on the
          dashboard reads, instead of a label stacked over a half-width select. */}
      <div className="ipSummaryPicker">
        <span className="implementing-partner">Implementing Partner</span>
        <Select
          placeholder="Select an IP"
          onChange={handlePartnerChange}
          loading={ipLoading}
          showSearch
          optionFilterProp="children"
          notFoundContent={ipLoading ? <Spin size="small" /> : "No data"}
        >
          {implementingPartners.map((implementingPartner) => (
            <Option key={implementingPartner.id} value={implementingPartner.id}>
              {implementingPartner.name}
            </Option>
          ))}
        </Select>
      </div>
      {selectedPartner && (
        <Spin spinning={loading}>
          <div className="ipSummaryBody">
            <div className="tpmSummaryProject">
              <div className="tpmSummaryProjectName">
                <div className="ipSummaryNameLeft">
                  <div className="circleIpSummary">
                    <img src={iconCal} alt="img"></img>
                  </div>
                  {projectData?.data?.ipResponse?.name}
                </div>
                {/* <Button onClick={handleShowEditIPModal} className="buttonEditIpName">
                  <img src={edit}></img>
                  </Button>
                  <EditIpModal visible={shpwIpModal} onClose={handleCloseIpModal} /> */}
              </div>
              {/* Name, country, state(s) and cities as one label/value grid —
                  they were two stacked full-width rows of flex:1 items, so a
                  label and its value could end up 400px apart. */}
              {(() => {
                const states =
                  projectData?.data?.ipResponse?.locations?.states || [];
                const cities =
                  projectData?.data?.ipResponse?.locations?.cities || [];
                let country = "";
                let stateNames = [];
                if (states.length > 0) {
                  country = states[0].country?.stateName || "";
                  stateNames = states.map((s) => s.stateName).filter(Boolean);
                }
                return (
                  <div className="ipSummaryProjectInfo">
                    <div className="profile-container">
                      <div className="profile-item">
                        <span className="ipNameLabel">Name</span>
                        <span className="ipNameValue">
                          {projectData?.data?.ipResponse?.name}
                        </span>
                      </div>
                      {country && (
                        <div className="profile-item">
                          <span className="ipNameLabel">Country</span>
                          <span className="ipNameValue">{country}</span>
                        </div>
                      )}
                      {stateNames.length > 0 && (
                        <div className="profile-item">
                          <span className="ipNameLabel">
                            {stateNames.length === 1 ? "State" : "States"}
                          </span>
                          <span className="ipNameValue">
                            {stateNames.join(", ")}
                          </span>
                        </div>
                      )}
                      {cities.length > 0 && (
                        <div className="profile-item">
                          <span className="ipNameLabel">
                            {cities.length === 1 ? "City" : "Cities"}
                          </span>
                          <span className="ipNameValue">
                            {cities.map((city) => city.name).join(", ")}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })()}
            </div>
            <div className="activitySnapshot">
              <h2 className="activitySnapshotHeader">Status Snapshot</h2>
                {/* <div className="activitySnapshotHeaderContainer">
                  <h2 className="activitySnapshotHeader">Activity Snapshot</h2>
                  <Radio.Group
                    className="radioButtonGroup"
                    defaultValue="completed"
                  >
                    <Radio value="completed" style={{ fontSize: "16px" }}>
                      Completed
                    </Radio>
                    <Radio value="planned" style={{ fontSize: "16px" }}>
                      Planned
                    </Radio>
                  </Radio.Group>
                </div> */}
                <div className="activitySnapshotResultCard">
                  <div className="activitySnapshotCard">
                    <div className="activitySnapshotNumber">
                      <h2 className="activitySnapshotNumber1">
                        {projectData?.data?.statusSnapshot?.siteVisitCards}
                      </h2>
                      <p className="activitySnapshotText">Site Visit Cards</p>
                    </div>
                    <div className="activitySnapshotImg">
                      <img src={snapshot1} alt="img"></img>
                    </div>
                  </div>
                  <div className="activitySnapshotCard">
                    <div className="activitySnapshotNumber">
                      <h2 className="activitySnapshotNumber1">
                        {projectData?.data?.statusSnapshot?.flagCards}
                      </h2>
                      <p className="activitySnapshotText">Flags Cards</p>
                    </div>
                    <div className="activitySnapshotImg">
                      <img src={snapshot2} alt="img"></img>
                    </div>
                  </div>
                  <div className="activitySnapshotCard">
                    <div className="activitySnapshotNumber">
                      <h2 className="activitySnapshotNumber1">
                        {projectData?.data?.statusSnapshot?.taskCards}
                      </h2>
                      <p className="activitySnapshotText">Task Cards</p>
                    </div>
                    <div className="activitySnapshotImg">
                      <img src={snapshot3} alt="img"></img>
                    </div>
                  </div>
                  <div className="activitySnapshotCard">
                    <div className="activitySnapshotNumber">
                      <h2 className="activitySnapshotNumber1">
                        {
                          projectData?.data?.statusSnapshot
                            ?.beneficiaryInterviews
                        }
                      </h2>
                      <p className="activitySnapshotText">
                        Beneficiary Interviews
                        <br />
                      </p>
                    </div>
                    <div className="activitySnapshotImg">
                      <img src={snapshot4} alt="img"></img>
                    </div>
                  </div>
                  <div className="activitySnapshotCard">
                    <div className="activitySnapshotNumber">
                      <h2 className="activitySnapshotNumber1">
                        {projectData?.data?.statusSnapshot?.kllInterviews}
                      </h2>
                      <p className="activitySnapshotText">KII Interviews</p>
                    </div>
                    <div className="activitySnapshotImg">
                      <img src={snapshot5} alt="img"></img>
                    </div>
                  </div>
                  <div className="activitySnapshotCard">
                    <div className="activitySnapshotNumber">
                      <h2 className="activitySnapshotNumber1">
                        {
                          projectData?.data?.statusSnapshot
                            ?.observationChecklists
                        }
                      </h2>
                      <p className="activitySnapshotText">
                        Observation Checklists
                      </p>
                    </div>
                    <div className="activitySnapshotImg">
                      <img src={snapshot6} alt="img"></img>
                    </div>
                  </div>
                </div>
              </div>
            <IpCards projectData={projectData}></IpCards>
            <SiteVisitCards projectData={projectData}></SiteVisitCards>
            <RedFlagCards projectData={projectData}></RedFlagCards>
            <ResourceSection projectData={projectData}></ResourceSection>
            {/* <Map selectedIP={selectedPartner} /> */}
            <MapComponent
              availableStatuses={[2, 3, 4, 5, 6]}
              selectedIP={selectedPartner}
            />
            {/* <LocationRatings ></LocationRatings> */}
            <TableView
              projectData={projectData}
              pageNumber={pageNumber}
              pageSize={pageSize}
              setPageNumber={setPageNumber}
              setPageSize={setPageSize}
            />
          </div>
        </Spin>
      )}
    </div>
  );
}

export default IpSummary;
